import {KazBlurImageComponent} from '../kaz-blur-image/kaz-blur-image.component';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import {ApiService} from "../../services/api.service";
import {Ad, PriceType} from "../../interfaces/ad";
import {getDummyPicture} from "../../utils/dummyImages";
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ImageSourcePipe } from '../../pipes/image-source.pipe';

@Component({
    selector: 'kaz-card-active-ads',
    templateUrl: './kaz-card-active-ads.component.html',
    styleUrls: ['./kaz-card-active-ads.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazBlurImageComponent, RouterLink, FaIconComponent, CurrencyPipe, DatePipe, ImageSourcePipe]
})
export class KazCardActiveAdsComponent implements OnInit {
  private _api = inject(ApiService);

  @Output() wasDeleted = new EventEmitter<void>();
  @Input() ad: Ad | null = null;
  updatedAd: Partial<Ad> | null = null;
  showDelete: boolean = false;

  async ngOnInit() {
  }

  async toggleReserved() {
    try {
      if (this.ad !== null) {
        this.updatedAd = {
          id: this.ad.id,
          reserved: !this.ad.reserved,
        };
        this.ad = await this._api.updateAd(this.updatedAd);
      }
    } catch (err) {

    }
  }

  toggleDelete() {
    this.showDelete = !this.showDelete;
  }

  async deleteAd() {
    try {
      if (this.ad !== null) {
        await this._api.deleteAd(this.ad.id);
      }
      this.wasDeleted.emit();
    } catch (err) {

    }
  }

  protected readonly getDummyPicture = getDummyPicture;

  editDisabled(ad: Ad) {
    const today = new Date();
    const firstPubDate = new Date(ad.publicationDate[0]);

    return (firstPubDate < today)
  }

    protected readonly PriceType = PriceType;
}
